/**
 * WEB-2351, возврат 1 — признак «воронке нужна проверка границ числа»: в теле
 * есть блок числа, веса или роста. Проверка (`numberBounds.ts`) едет в едином
 * ленивом куске плеера; по этому признаку страница ждёт кусок до первого
 * кадра (`usePlayerKitDoor`), и шлагбаум к первому нажатию уже судит
 * границы. Признак по ТИПУ блока, не по значениям границ: блок с границами
 * по умолчанию тоже заказывает кусок (лишний запрос, не пропуск проверки).
 * Не бросает (петля в теле — «не нужен»).
 */
const USES_BOUNDS = /"type":"(?:number_input|weight_picker|height_picker)"/;

export function funnelUsesNumberBounds(body: unknown): boolean {
  if (body === null || body === undefined) return false;
  try {
    return USES_BOUNDS.test(JSON.stringify(body) ?? '');
  } catch {
    return false;
  }
}
